import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { selectIsModalDiagramImportSqlEnabled, selectModalDiagramImportSqlData } from '../../../redux/main/main.selectors';
import { toggleDiagramImportSql } from '../../../redux/main/main.actions';


import Modal from '../Modal/Modal';

import './ModalDiagramImportSql.scss';


function getModalContent(type, t) {
    const contentMap = {
        sql: {
            name: t('m_diagram_import.sql_name'),
            desc: t('m_diagram_import.placeholder'),
        },
        dbml: {
            name: t('m_diagram_import.dbml_name'),
            desc: t('m_diagram_import.placeholder'),
        },
    };
    if (['sql', 'dbml'].includes(type)) {
        return contentMap[type];
    }
    return contentMap['sql'];
}


export const ModalDiagramImportSql = () => {
    const { t } = useTranslation();
    const isOpen = useSelector(selectIsModalDiagramImportSqlEnabled);

    const dispatch = useDispatch();

    const inputRef = useRef(null);
    const [content, setContent] = useState(null);

    const modalType = useSelector(selectModalDiagramImportSqlData);

    useEffect(() => {
        if (modalType) {
            const modalContent = getModalContent(modalType, t);
            setContent(modalContent);
        }
        return () => { };
    }, [modalType]);


    const [value, setValue] = useState('');

    const handleSave = () => {
        if (value) {
            // dispatch(sendSupportRequest(value));
            dispatch(toggleDiagramImportSql(null));
            setTimeout(() => {
                setValue('');
            }, 300);
        }
    };

    const handleCancel = () => {
        setTimeout(() => {
            setValue('');
        }, 300);
        dispatch(toggleDiagramImportSql(null));
    };

    const handleRender = () => {
        if (isOpen && inputRef.current) {
            inputRef.current.focus();
        }
    };

    if (!content) return null;

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-diagram-import-sql`}
            onCancel={handleCancel}
            onShouldRender={handleRender}
        >
            <div className="modal-content-header">{content.name}</div>
            <div className="modal-content-body">
                <textarea
                    maxLength="20000"
                    ref={inputRef}
                    autoComplete="off"
                    autoFocus={(window.innerWidth >= 1000)}
                    spellCheck="false"
                    placeholder={content.desc}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                />
                <button
                    disabled={!value}
                    onClick={() => handleSave()}>{t('b.import')}</button>
            </div>
        </Modal>
    );
};

export default ModalDiagramImportSql;
